import { useState } from "react";
// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  Paper,
} from "@mui/material";
import { styled } from "@mui/system";
import EditNoteIcon from "@mui/icons-material/EditNote";

// InterFace
import { EditDataDifine } from "../../config/dataInterface";
import { LIST_POST } from "../../config/const";
import { useWindowSize } from "../../lib/useWindowSize";

interface PasswordEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editPassword: {
    status: "before" | "editing" | "success" | "failed" | string;
    oldPassword: string;
    newPassword1: string;
    newPassword2: string;
  } | null;
  setEditPassword: (
    data: {
      status: "before" | "editing" | "success" | "failed" | string;
      oldPassword: string;
      newPassword1: string;
      newPassword2: string;
    } | null
  ) => void;
  putEditData: () => void;
}
const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

export function PasswordEditModal(props: PasswordEditModalProps) {
  const { onModal, swCloseModal, editPassword, setEditPassword, putEditData } =
    props;
  const { windowWidth, windowHeight } = useWindowSize();
  const [value, setValue] = useState("");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return editPassword ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          編集 - パスワード
        </Box>
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            mb: 5,
            maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
            overflowY: windowWidth > 385 ? undefined : "auto",
          }}
        >
          <Paper elevation={0}>
            {editPassword.status === "before" ? (
              <>
                <Box key="old-pass">
                  <Box className="serch-label">旧パスワード</Box>
                  <CustomTextField
                    type={"password"}
                    id="textFieldId"
                    value={editPassword.oldPassword}
                    size="small"
                    onChange={(e) =>
                      setEditPassword({
                        ...editPassword,
                        oldPassword: e.target.value,
                      })
                    }
                    sx={{ width: "calc(100% - 10px)", margin: "10px 5px " }}
                  />
                </Box>
                <Box key="new-pass-1">
                  <Box className="serch-label">新規パスワード</Box>
                  <CustomTextField
                    type={"password"}
                    id="textFieldId"
                    value={editPassword.newPassword1}
                    size="small"
                    onChange={(e) =>
                      setEditPassword({
                        ...editPassword,
                        newPassword1: e.target.value,
                      })
                    }
                    sx={{ width: "calc(100% - 10px)", margin: "10px 5px " }}
                  />
                </Box>
                <Box key="new-pass-2">
                  <Box className="serch-label">新規パスワード（確認用）</Box>
                  <CustomTextField
                    type={"password"}
                    id="textFieldId"
                    value={editPassword.newPassword2}
                    size="small"
                    onChange={(e) =>
                      setEditPassword({
                        ...editPassword,
                        newPassword2: e.target.value,
                      })
                    }
                    sx={{ width: "calc(100% - 10px)", margin: "10px 5px " }}
                  />
                </Box>
                <Box
                  style={{ display: windowWidth > 385 ? "flex" : undefined }}
                >
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? undefined : "5px",
                    }}
                  >
                    <Button
                      disabled={
                        editPassword.oldPassword === "" ||
                        editPassword.newPassword1 === "" ||
                        editPassword.newPassword2 === "" ||
                        editPassword.newPassword1 !== editPassword.newPassword2
                      }
                      variant="contained"
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={putEditData}
                    >
                      <Box
                        className="m-plus-rounded-1c-regular"
                        style={{
                          color:
                            editPassword.oldPassword === "" ||
                            editPassword.newPassword1 === "" ||
                            editPassword.newPassword2 === "" ||
                            editPassword.newPassword1 !==
                              editPassword.newPassword2
                              ? "rgb(70 70 70)"
                              : undefined,
                        }}
                      >
                        編集
                      </Box>
                      <EditNoteIcon
                        sx={{
                          marginLeft: "6px",
                          color:
                            editPassword.oldPassword === "" ||
                            editPassword.newPassword1 === "" ||
                            editPassword.newPassword2 === "" ||
                            editPassword.newPassword1 !==
                              editPassword.newPassword2
                              ? "rgb(70 70 70)"
                              : "white",
                        }}
                        fontSize="medium"
                      />
                    </Button>
                  </Box>
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? "10px" : "5px",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={swCloseModal}
                    >
                      <Box className="m-plus-rounded-1c-regular">
                        キャンセル
                      </Box>
                    </Button>
                  </Box>
                </Box>
              </>
            ) : editPassword.status === "success" ? (
              <>
                <Box className="shippori-antique-regular">
                  パスワードの編集に成功しました。
                </Box>
                <Box>
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </>
            ) : editPassword.status === "failed" ? (
              <>
                <Box className="shippori-antique-regular">
                  パスワードの編集に失敗しました。
                  <br />
                  データの形式が異なる可能性があります。
                </Box>
                <Box>
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditPassword({
                        ...editPassword,
                        status: "before",
                      })
                    }
                  >
                    <Box className="m-plus-rounded-1c-regular">OK</Box>
                  </Button>
                </Box>
              </>
            ) : editPassword.status === "NotPolicy" ? (
              <>
                <Box className="shippori-antique-regular">
                  パスワードの要件を満たしていません。
                  <br />
                  大文字・小文字・数字・記号を含む
                  <br />
                  8文字以上の文字列をご入力ください
                </Box>
                <Box>
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditPassword({
                        ...editPassword,
                        status: "before",
                      })
                    }
                  >
                    <Box className="m-plus-rounded-1c-regular">OK</Box>
                  </Button>
                </Box>
              </>
            ) : editPassword.status === "Incorrect" ? (
              <>
                <Box className="shippori-antique-regular">
                  旧パスワードの情報が異なります。
                </Box>
                <Box>
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditPassword({
                        ...editPassword,
                        status: "before",
                      })
                    }
                  >
                    <Box className="m-plus-rounded-1c-regular">OK</Box>
                  </Button>
                </Box>
              </>
            ) : null}
          </Paper>
        </Typography>
      </Box>
    </Modal>
  ) : null;
}
